import script from "./LandingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingView.vue?vue&type=script&setup=true&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=2e92abd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e92abd2"]])

export default __exports__